module.exports = __webpack_public_path__ + "static/media/image_24.8ebd2fbc.png";